import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  CardActions,
  CardMedia,
  CardContent,
  Typography,
  Stack,
} from '@mui/material';
import {
  MoreBookingsCard,
  MoreBookingsModal,
  MoreBookingsStack,
} from './components';

function MoreBookingsPromoModal({ open = false, onClose = () => {} }) {
  return (
    <MoreBookingsModal
      open={open}
      aria-labelledby='more-bookings-promo-subtitle'
      aria-describedby='more-bookings-promo-title'
      disableEscapeKeyDown={true}>
      <MoreBookingsCard>
        <CardMedia
          component='img'
          height='192'
          image='https://s3.eu-west-2.amazonaws.com/venue.scanner/img/more-bookings-media.png'></CardMedia>
        <MoreBookingsStack spacing={4}>
          <CardContent>
            <Typography variant='subtitle1' id='more-bookings-promo-subtitle'>
              Do you want more booking?
            </Typography>
            <Typography
              variant='h5'
              component='h1'
              id='more-bookings-promo-title'>
              Get 5X more bookings with a VenueScanner membership
            </Typography>
          </CardContent>
          <CardActions>
            <Stack direction='row' spacing={1}>
              <Button
                href='https://venuescanner.webflow.io/landing/case-study/more-bookings'
                target='_blank'
                rel='noreferrer'
                size='large'
                variant='contained'>
                Show details
              </Button>
              <Button variant='text' size='large' onClick={onClose}>
                Close
              </Button>
            </Stack>
          </CardActions>
        </MoreBookingsStack>
      </MoreBookingsCard>
    </MoreBookingsModal>
  );
}

MoreBookingsPromoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default MoreBookingsPromoModal;
